module.exports = __webpack_public_path__ + "static/media/check-white.76557ece.svg";